import { useState } from 'react'
import { useSearchParams, useNavigate, Link } from 'react-router-dom'
import { customerApi } from '../../services/customerAuth'
import { useLanguage } from '../../context/LanguageContext'

export default function CustomerSignup() {
  const { t } = useLanguage()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const prefilledEmail = searchParams.get('email') || ''

  const [form, setForm] = useState({
    email: prefilledEmail, password: '', firstName: '', lastName: '', phone: '',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [done, setDone] = useState(false)

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }))

  async function submit(e) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await customerApi.post('/customer/signup', form)
      setDone(true)
    } catch (err) {
      setError(err.response?.data?.message || t('sp_could_not_create_account', 'Could not create account'))
    } finally {
      setLoading(false)
    }
  }

  if (done) {
    return (
      <Shell>
        <h2 style={{ color: '#153230', margin: '0 0 12px' }}>{t('sp_check_your_email', 'Check your email')}</h2>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          {t('sp_verification_sent_to', 'We\'ve sent a verification link to')} <strong>{form.email}</strong>. {t('sp_click_to_activate', 'Click the link to activate your account and we\'ll connect any existing trips automatically.')}
        </p>
        <p style={{ fontSize: 13, color: '#94a3b8', marginTop: 20 }}>
          {t('sp_didnt_get_it', 'Didn\'t get it? Check your spam folder, or')} <Link to="/customer/login">{t('sp_try_logging_in', 'try logging in')}</Link> {t('sp_if_have_account', 'if you already have an account.')}
        </p>
      </Shell>
    )
  }

  return (
    <Shell>
      <h2 style={{ color: '#153230', margin: '0 0 6px' }}>{t('sp_create_your_playstay_account', 'Create your PlayStay account')}</h2>
      <p style={{ color: '#64748b', margin: '0 0 20px', fontSize: 14 }}>{t('sp_manage_trips', 'Manage your Stay & Play trips in one place.')}</p>
      <form onSubmit={submit}>
        <Field label={t('email', 'Email')} type="email" value={form.email} onChange={set('email')} required disabled={!!prefilledEmail} />
        <Field label={t('sp_password_min_8', 'Password (min 8 chars)')} type="password" value={form.password} onChange={set('password')} required minLength={8} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <Field label={t('sp_first_name', 'First name')} value={form.firstName} onChange={set('firstName')} />
          <Field label={t('sp_last_name', 'Last name')} value={form.lastName} onChange={set('lastName')} />
        </div>
        <Field label={t('sp_phone_optional', 'Phone (optional)')} type="tel" value={form.phone} onChange={set('phone')} />
        {error && <div style={{ padding: 10, background: '#fee2e2', color: '#991b1b', borderRadius: 6, fontSize: 13, margin: '10px 0' }}>{error}</div>}
        <button type="submit" disabled={loading} style={btnPrimary}>
          {loading ? t('sp_creating', 'Creating…') : t('sp_create_account', 'Create account')}
        </button>
      </form>
      <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#64748b' }}>
        {t('sp_already_have_account', 'Already have an account?')} <Link to="/customer/login" style={{ color: '#00d19f', fontWeight: 600 }}>{t('sp_log_in', 'Log in')}</Link>
      </div>
    </Shell>
  )
}

function Shell({ children }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '40px 16px', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 420, margin: '0 auto', background: '#fff', padding: 28, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        {children}
      </div>
    </div>
  )
}

function Field({ label, ...rest }) {
  return (
    <label style={{ display: 'block', margin: '10px 0' }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4 }}>{label}</div>
      <input {...rest} style={inputStyle} />
    </label>
  )
}

const inputStyle = {
  width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1',
  borderRadius: 6, fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit',
}

const btnPrimary = {
  width: '100%', padding: '12px', background: '#00d19f', color: '#153230',
  border: 'none', borderRadius: 6, fontWeight: 700, fontSize: 15, cursor: 'pointer',
  marginTop: 10,
}
